export const SitemapController = {
    index(): void {},
};
